import { bannersApi } from "@features/banners/store";
import { CategoryDetailsPageProps } from "@features/categories/pages/CategoryDetailsPage";
import { CategoryDetailsPage } from "@features/categories/pages/CategoryDetailsPage/dynamic";
import { categoriesApi } from "@features/categories/store";
import { productsApi } from "@features/products/store";
import { decodeProductsParams } from "@features/products/utils/decodeProductsParams";
import { mapParamsToProductPageRequest } from "@features/products/utils/mapParamsToProductPageRequest";
import { getAppServerSideProps } from "@features/ssr/utils/getAppServerSideProps";
import { GetServerSideProps } from "next";

export const getServerSideProps: GetServerSideProps = getAppServerSideProps(
  async (store, ctx) => {
    //const id = decodeNumber(ctx.params?.id);

    const idParam = ctx.params?.id;

    const { page, searchType, searchText } = decodeProductsParams(ctx.params);

    if (!idParam) {
      return {
        notFound: true,
      };
    }

    if (typeof idParam !== "string") {
      return {
        notFound: true,
      };
    }

    const match = idParam.match(/^(\d+)-/);

    if (!match) {
      return {
        notFound: true,
      };
    }

    const id = Number(match[1]);

    const currency = store.getState().currency.value;
    const countryId = store.getState().citySlice.countryId;

    const promises = [
      store.dispatch(
        categoriesApi.endpoints.getCategory.initiate({
          id,
          country: countryId,
        }),
      ),
      store.dispatch(
        productsApi.endpoints.getProductPage.initiate({
          ...mapParamsToProductPageRequest({
            page,
            searchText,
            searchType,
            //TODO Добавить фильтр
          }),
          category: id,
          //recommendation: true,
          currency: currency,
          country: countryId ?? 0,
        }),
      ),
      store.dispatch(
        bannersApi.endpoints.getBanners.initiate({ slug: "section-2" }),
      ),
    ] as const;

    const res = await Promise.all(promises);

    const categoryRequest = res[0];

    const productPageRequest = res[1];

    if (!res[0].isSuccess) {
      return {
        notFound: true,
      };
    }

    const category = categoryRequest.data;
    const productSSR = productPageRequest.data;

    // console.log("что за Категории получаем:", category?.id, category?.title);
    // console.log("город ", countryId, currency);

    return {
      props: { category, productSSR } as CategoryDetailsPageProps,
    };
  },
);

export default CategoryDetailsPage;
